// extracted by mini-css-extract-plugin
module.exports = {"empresa-user-role-warn":"style_empresa-user-role-warn__1dP-J","link-roles":"style_link-roles__qXkt6"};